import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { ToastComponent } from '../../shared/toast/toast.component';
import { AuthService } from '../../services/auth.service';
import { AlertService } from '../../services/alert.service';
import { setClassInvalid } from '../../shared/functions';
import { ee } from '../../shared/constants';

@Component({
  selector: 'app-add-alert-form',
  templateUrl: './add-alert-form.component.html',
  standalone: false
})
export class AddAlertFormComponent implements OnInit, OnDestroy {
  auth = inject(AuthService);
  private alertService = inject(AlertService);
  private formBuilder = inject(UntypedFormBuilder);
  toast = inject(ToastComponent);


  @Input() keyword: string;
  @Input() person: string;
  @Input() noperson: string;
  @Input() source: string;
  @Input() lang: string;
  @Input() party: string;
  @Input() organ: string;
  @Input() commission: string;
  @Input() country: string;
  @Input() isLoadingSearch: boolean;

  addAlertForm = this.createAlertForm();
  setClassInvalid = setClassInvalid;

  ngOnInit(): void {
    ee.on('searchInput', (obj: any) => this.addAlertForm.patchValue(obj));
  }

  ngOnDestroy(): void {
    ee.off('searchInput', () => {});
  }

  createAlertForm(): UntypedFormGroup {
    return this.formBuilder.group({
      name: ['', Validators.required],
      _users: [[this.auth.currentUser._id], Validators.required],
    });
  }

  addAlert(): void {
    const alertName = this.addAlertForm.get('name').value;
    const alert = {
      name: alertName,
      query: {
        keyword: this.keyword,
        person: this.person,
        noperson: this.noperson,
        source: this.source,
        lang: this.lang,
        party: this.party,
        organ: this.organ,
        commission: this.commission,
        country: this.country,
      },
      email: this.auth.currentUser.email,
      _users: this.addAlertForm.get('_users').value
    };
    this.alertService.add(alert)
      .subscribe({
        next: res => this.toast.setMessage(`Alert "${alertName}" created successfully`, 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

}
